import { api } from "..";

import { CategoryCouponsStatements } from "@/types/ApiResponses/Coupon";
import { QueryProps } from "@/types/Api";

interface QueryParams {
  type?: string;
  category?: string;
  startDate?: string;
  endDate?: string;
  dealerIds?: number[];
  subDealerIds?: number[];
  userIds?: number[];
  statusList?: string[];
  names?: string[];
  sportCategory?: string;
  matchId?: string;
  q?: string;
  /** Scopes the statistics to the trash bin's soft-deleted coupons. */
  deleted?: boolean;
}

export const getCouponsStatements = async (
  props: QueryProps<QueryParams>
): Promise<CategoryCouponsStatements> => {
  const res = await api.client.get(`/users-new/coupons/statement`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
